import { render, staticRenderFns } from "./cascader-pane.vue?vue&type=template&id=4b2a6712&"
import script from "./cascader-pane.vue?vue&type=script&lang=js&"
export * from "./cascader-pane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cascader-pane.vue"
export default component.exports